// extracted by mini-css-extract-plugin
export default {"headerBar":"Hospitals_headerBar__ZCxF0"};